import React, { useCallback, useState } from "react";
import usePost from "Hooks/usePost";
import { useRouteLoaderData, useNavigate, Link } from "react-router-dom";
import { updateUser, deleteUser } from "API/swesum";

import { InputLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export default function UserDetails({ user, userTypes }) {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    UserId: user.AppUserId,
    Username: user.Username,
    Password: "default",
    Usertype: user.Usertype,
  });

  const { openError } = usePopupNotificationContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  const updateUserReq = usePost({
    mtnFunc: (inputs) => {
      return updateUser(user.Id, inputs);
    },
    onSuccess: () => {
      navigate("/users");
    },
    onError: (err) => {
      err?.response?.data
        ? openError(err?.response?.data, 10000)
        : openError("Ett fel uppstod när användaren skulle uppdateras.", 10000);
    },
  });

  const deleteUserReq = usePost({
    mtnFunc: (inputs) => {
      return deleteUser(user.AppUserId);
    },
    onSuccess: (data) => {
      navigate("/users");
    },
    onError: () => {
      openError("Ett fel har uppstått.", 6000);
    },
  });

  const submit = () => {
    if (inputs.Password === "default") {
      updateUserReq.post({
        UserId: inputs.AppUserId,
        Username: inputs.Username,
        Usertype: inputs.Usertype,
      });
    } else {
      updateUserReq.post(inputs);
    }
  };

  const handleChange = useCallback((e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }, []);

  const closeDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} md={12}>
          <TextField
            name="Username"
            label="Epost"
            defaultValue={inputs.Username}
            onChange={(e) => handleChange(e)}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            name="Password"
            label="Password"
            type="password"
            defaultValue={inputs.Password}
            onChange={(e) => handleChange(e)}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>Roll</InputLabel>
            <Select
              name="Usertype"
              value={inputs.Usertype}
              label="Role"
              onChange={(e) => handleChange(e)}
              size="small"
            >
              {userTypes.map((type) => (
                <MenuItem key={type.Value} value={type.Value}>
                  {type.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {/* <Button
              variant="contained"
              color="error"
              onClick={() => setDialogOpen(true)}
            >
              Ta bort
              </Button>*/}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}
            >
              <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
                Stäng
              </Button>
              <Button onClick={submit} variant="contained" sx={{ ml: 3 }}>
                Spara
              </Button>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{"Ta bort användare"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Användaren kommer att tas bort från systemet. Åtgärden går inte att ångra."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Stäng</Button>
          <Button color="error" onClick={() => deleteUserReq.post()} autoFocus>
            Ta bort
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
